<template>
  <div class="vdl-user-info" :class="{'vdl-user-info_content': hasContent, 'has-click': clickable }"  @click="onCardClick">
    <div>
      <md-avatar :class="{ 'mini': mini }">
        <div>
          <span class="centered-image" :id="index ? section + 'va-avatar-' + index : undefined" v-bind:style="styleObject"
          role="img" :aria-label="altText"> </span>
        </div>
      </md-avatar>
    </div>
    <div class="name" :class="{'name-overflow': limitTextOneLine, 'extended-header': extendedCard}">
      <div>
        <span :id="index ? section + 'va-name-' + index : undefined"  class="md-subheading">{{name}}</span><slot name="after-name"></slot>
        <vdl-basic-membership
          :clickable="clickable"
          v-if="showBadge && (isAi || membershipType)"
          :type="membershipType"
          :provider="provider"
          :isAi="isAi"
          :size="19"
        ></vdl-basic-membership>
      </div>
      <div v-show="extendedCard" class="va-stats-container">
          <span v-if="providerRating && provider.stats.reviews_count" class="span-stats">
            <vdl-basic-rating-stars class="inline-flex stars" :rate="providerRating" @change="$emit('change:rating-stars', $event)"></vdl-basic-rating-stars>
            ({{provider.stats && provider.stats.reviews_count}})
          </span>
      </div>
      <md-tooltip md-direction="top" v-if="hasTooltip">{{content}}</md-tooltip>
      <slot name="content">
        <p class="content-text item-info" v-if="content">
          <span v-if="hasQuotationMark">"</span>{{content}}<span v-if="hasQuotationMark">"</span>
        </p>
      </slot>

    </div>
  </div>
</template>

<script src="./vdlBasicUserInfo.mjs"></script>
<style src="./vdlBasicUserInfo.scss" lang="scss" scoped></style>